import React from "react";

// Simple, scannable project card — no flip/tilt gimmick. A plain link with an
// image, name, one-line description, and tech stack, so it's fully keyboard
// and screen-reader accessible for free (it's just an <a>).
export default function ProjectMiniCard(props) {
    const { obj } = props;
    const isExternal = Boolean(obj.link);

    const content = (
        <>
            <div className="miniProjectImgWrap">
                <img className="miniProjectImg" src={obj.img} alt={`${obj.name} preview`} />
            </div>
            <div className="miniProjectBody">
                <h4 className="miniProjectName">{obj.name}</h4>
                <p className="miniProjectDesc">{obj.desc}</p>
                <p className="miniProjectTech">{obj.tech}</p>
            </div>
        </>
    );

    if (!isExternal) {
        return <div className="miniProjectCard" aria-disabled="true">{content}</div>;
    }

    return (
        <a
            className="miniProjectCard"
            href={obj.link}
            target="_blank"
            rel="noreferrer"
            aria-label={`Open ${obj.name} project`}
        >
            {content}
        </a>
    );
}
